// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"9f0efacf","453":"8ddd5697","455":"d336f409"}[chunkId] + ".chunk.js";
};